export function initScrollSpy() {
  const sections = document.getElementsByTagName("section");
  const links = document.querySelectorAll("header nav a");
  if (!sections.length || !links.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const id = entry.target.getAttribute("id");
        links.forEach((link) => {
          link.classList.toggle("active", link.getAttribute("href").includes(`#${id}`));
        });
      });
    },
    { rootMargin: "-50% 0px" },
  );

  Array.from(sections).forEach((s) => observer.observe(s));
}
